import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ButtonSize,
  ButtonVariant,
} from '@app/modules/editor/shared/as-components/button/button.component';
import { HTMLElementModel } from '../../models/content.model';

@Component({
  selector: 'inline-image-editor-link',
  templateUrl: './inline-image-editor-link.component.html',
  styleUrl: './inline-image-editor-link.component.scss',
  standalone: false,
})
export class InlineImageEditorLinkComponent implements OnInit {
  btnSize = ButtonSize;

  btnVariant = ButtonVariant;

  @Output() command = new EventEmitter<{ cmd: string; val: string }>();

  form!: FormGroup;

  htmlString: string;

  overlayTheme = '';

  value: HTMLElement;

  anchor: string;

  inputForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InlineImageEditorLinkComponent>,
    @Inject(MAT_DIALOG_DATA) public html: HTMLElementModel
  ) {
    this.value = html.data;
    this.anchor = html.anchor;
  }

  ngOnInit(): void {
    let preset = this.anchor;
    if (!this.anchor) {
      preset = 'https://';
    }
    this.form = this.fb.group({
      value: [preset, [Validators.required]],
    });
  }

  confirm(): void {
    if (this.form.invalid) {
      return;
    }

    const href = this.form.value.value;

    this.dialogRef.close(href);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
